<template>
  <div class="global-uploader">
    <uploader
      ref="uploader"
      :options="options"
      :autoStart="true"
      :fileStatusText="fileStatusText"
      @file-added="onFileAdded"
      @file-success="onFileSuccess"
      @file-progress="onFileProgress"
      @file-error="onFileError"
      class="uploader-app"
    >
      <uploader-unsupport></uploader-unsupport>

      <uploader-btn v-show="false" ref="uploadBtn">选择文件</uploader-btn>

      <uploader-list>
        <div slot-scope="props">
          <div
            class="d-flex justify-content-between upload-header"
            v-show="props.fileList.length"
          >
            <div class="upload-title">
              {{ uploadTitle }}
            </div>
            <div class="upload-opts">
              <el-tooltip effect="dark" content="全部取消" placement="top">
                <span @click.stop="cancel"><i class="el-icon-close"/></span>
              </el-tooltip>
              <template v-if="pendingNum">
                <el-tooltip effect="dark" content="全部暂停" placement="top">
                  <span @click.stop="pause"
                    ><i class="el-icon-video-pause"
                  /></span>
                </el-tooltip>
                <el-tooltip effect="dark" content="全部继续" placement="top">
                  <span @click.stop="resume"
                    ><i class="el-icon-refresh-right"
                  /></span>
                </el-tooltip>
              </template>
            </div>
          </div>

          <div class="upload-body" v-show="uploaderShowList">
            <div class="file-list">
              <div
                v-for="file in props.fileList"
                :key="file.id"
                class="file-item"
              >
                <upfile :file="file" :list="true"></upfile>
              </div>
              <div class="no-file" v-if="!props.fileList.length">
                <i class="fa fa-cloud-upload icon-upload"></i>
                <div class="upload__text">
                  {{ $l('INDEX.uploader_label_empty') || '暂无上传任务' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </uploader-list>
    </uploader>
  </div>
</template>

<script>
/**
 *   全局上传插件
 *   监听函数：Bus.$on('fileAdded', fn); 文件选择后的回调
 *            Bus.$on('fileSuccess', fn); 文件上传成功的回调
 */

// import { ACCEPT_CONFIG } from './js/config'
import SparkMD5 from 'spark-md5'
import Bus from './js/bus'
import { request } from '@/api/service'
import { mapState, mapActions, mapGetters } from 'vuex'
import upfile from './file'
import { Message } from 'element-ui'

export default {
  name: 'upload',
  props: {
    showList: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uploaderShowList: false,
      options: {
        target: (file, chunk, isTest) => {
          // if (isTest) {
          //   return '/oss/checkChunk'
          // }
          return '/oss/upload'
        },
        chunkSize: '2048000',
        fileParameterName: 'file',
        maxChunkRetries: 3,
        simultaneousUploads: 1,
        allowDuplicateUploads: true,
        testChunks: true, // 是否开启服务器分片校验
        successStatuses: [200],
        // 服务器分片校验函数，秒传及断点续传基础
        checkChunkUploadedByResponse: function(chunk, res) {
          let resObj = JSON.parse(res)
          const { status, msg } = resObj
          if (status != 200) {
            chunk.file.error = true
            Message.error(
              this.$l('INDEX.uploader_message_status_failed') || '上传失败'
            )
            throw msg
          }
          let data = resObj.body
          if (data.skipUpload) {
            return true
          }
          return (data.uploaded || []).indexOf(chunk.offset + 1) >= 0
        },
        // headers: {
        //     Authorization: Ticket.get() && "Bearer " + Ticket.get().access_token
        // },
        query() {},
        processParams(params, file, chunk, isTest) {
          params.identifier = file.md5 + '.' + file.getExtension()
          if (!isTest) {
            params = { ...params, params: JSON.stringify(file.params) }
          }
          return params
        }
      },
      // attrs: {
      //   accept: ACCEPT_CONFIG.getAll()
      // }
      fileStatusText: {
        success: this.$l('INDEX.uploader_label_status_success') || '上传成功',
        error: this.$l('INDEX.uploader_label_status_error') || '上传失败',
        uploading: this.$l('INDEX.uploader_label_status_uploading') || '上传中',
        paused: this.$l('INDEX.uploader_label_status_paused') || '已暂停',
        waiting: this.$l('INDEX.uploader_label_status_waiting') || '等待上传',
        md5: this.$l('INDEX.uploader_label_status_md5') || '校验文件中'
      }
    }
  },
  computed: {
    ...mapState('admin/upload', [
      'opened',
      'addFile',
      'files',
      'pendingNum',
      'isUploading'
    ]),
    ...mapGetters('admin/upload', ['number']),
    uploader() {
      return this.$refs.uploader.uploader
    },
    uploadTitle() {
      if (!this.pendingNum) {
        return `上传完成 - 共${this.number}项`
      }
      return (
        (this.isUploading ? '正在上传' : '上传已暂停') +
        ` ‑ 剩余${this.pendingNum}项`
      )
    }
  },
  created() {
    this.uploaderShowList = this.showList
  },
  mounted() {
    // 启用拖拽上传
    this.uploader.assignDrop(this.$el)
    this.init({
      uploader: this.uploader,
      uploadBtn: this.$refs.uploadBtn.$el
    })
  },
  methods: {
    ...mapActions('admin/upload', [
      'add',
      'init',
      'cancel',
      'callback',
      'resume',
      'pause'
    ]),
    // eslint-disable-next-line no-unused-vars
    async onFileAdded(file) {
      // 如果文件已经存在，就不添加到上传列表了
      if (this.uploader.getFromUniqueIdentifier(file.uniqueIdentifier)) {
        file.ignored = true
      }
      await this.computeMD5(file)
      await this.getSuffix(file)
      this.$nextTick(() => {
        this.callback({ file, event: 'added' })
      })
      // new Promise((resolve) => {
      //   this.getSuffix(file)
      //   resolve()
      // }).then(() => {
      //   this.$nextTick(() => {
      //     this.callback({ file, event: 'added' })
      //   })
      // })
    },
    // eslint-disable-next-line no-unused-vars
    onFileProgress(rootFile, file, chunk) {
      // console.log('块:', chunk, file, chunk.bytes)
      // console.log(
      //   `上传中 ${file.name}，chunk：${chunk.startByte /
      //     1024 /
      //     1024} ~ ${chunk.endByte / 1024 / 1024}`
      // )
    },
    onFileSuccess(rootFile, file, response) {
      let res = JSON.parse(response)
      const { status, msg } = res
      // 服务器自定义的错误（即虽返回200，但是是错误的情况），这种错误是Uploader无法拦截的
      if (status !== 200) {
        this.callback({ file, event: 'fail', message: msg })
        Message.error(
          this.$l('INDEX.uploader_message_status_failed') || '上传失败'
        )
        return
      }
      // 文件上传成功
      Bus.$emit('fileSuccess', res)

      // 如果服务端返回需要合并
      if (res.body.merge) {
        request({
          url: '/oss/bigFileMerge',
          method: 'post',
          data: {
            identifier: res.body.resourceId,
            fileName: res.body.filename
          }
        })
      }

      this.callback({ file, event: 'success' })

      Message.success(
        this.$l('INDEX.uploader_message_status_success') || '上传成功'
      )
    },
    // eslint-disable-next-line no-unused-vars
    onFileError(rootFile, file, response) {
      this.callback({ file, event: 'fail', message: response })
      Message.error(
        this.$l('INDEX.uploader_message_status_failed') || '上传失败'
      )
    },
    error(msg) {
      this.$notify({
        title: '错误',
        message: msg,
        type: 'error',
        duration: 2000
      })
    },
    response(res) {
      console.log(res)
      return JSON.parse(res)
    },
    /**
     * 计算md5，实现断点续传及秒传
     * @param file
     */
    async computeMD5(file) {
      file.status = 'md5'
      let fileReader = new FileReader()
      let time = new Date().getTime()
      let blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice
      let currentChunk = 0
      const chunkSize = 10 * 1024 * 1000
      let chunks = Math.ceil(file.size / chunkSize)
      let spark = new SparkMD5.ArrayBuffer()
      file.pause()
      return await new Promise((resolve) => {
        loadNext()
        fileReader.onload = (e) => {
          spark.append(e.target.result)
          if (currentChunk < chunks) {
            currentChunk++
            loadNext()
          } else {
            let md5 = spark.end()
            file.md5 = md5
            resolve(md5)
            file.resume()
            file.status = ''
            // console.log(
            //   `MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${
            //     file.size
            //   } 用时：${new Date().getTime() - time} ms`
            // )
          }
        }
        fileReader.onerror = function() {
          this.error(`文件${file.name}读取出错，请检查该文件`)
          file.cancel()
        }
        function loadNext() {
          let start = currentChunk * chunkSize
          let end =
            start + chunkSize >= file.size ? file.size : start + chunkSize
          fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end))
        }
      })
    },
    getSuffix(file) {
      let suffix = file.name
        .split('.')
        .pop()
        .toLowerCase()
      file.suffix = suffix
    }
  },
  components: {
    upfile
  }
}
</script>

<style scoped lang="scss">
.file-list {
  max-height: 300px;
  overflow-y: auto;
}
.file-list::-webkit-scrollbar {
  width: 2px;
  height: 1px;
}
.file-list::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #b1b1b1;
}

.file-list::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}

.global-uploader {
  .no-file {
    padding: 20px;
    text-align: center;
  }

  .uploader-file {
    border-bottom: none;
  }

  .file-item {
    position: relative;
    padding: 10px 16px;
    &:hover {
      cursor: pointer;
    }
  }

  .uploader-file-icon {
    &:before {
      content: '' !important;
    }
  }

  .uploader-file-actions > span {
    margin-right: 6px;
  }
}
</style>
<style lang="scss">
.global-uploader {
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #ebeef5;

  .upload-header {
    padding: 0 16px;
    height: 54px;
    display: flex;
    align-items: center;
    // &:hover {
    //   background-color: #f5f7fa;
    //   cursor: pointer;
    // }

    .upload-title {
      font-size: 14px;
      font-weight: 500;
    }
  }
  .upload-body {
    // padding: 16px;
    padding-bottom: 10px;
  }

  .no-file {
    .icon-upload {
      font-size: 60px;
      color: #c0c4cc;
      margin: 0 0 16px;
      // line-height: 50px;
    }
    .upload__text {
      color: #606266;
      font-size: 12px;
      text-align: center;
    }
  }
  .upload-opts {
    i {
      font-size: 16px;
    }
    span {
      border-radius: 100%;
      padding: 2px 4px;
      margin-left: 8px;
      background-color: #f5f5f5;
      color: #909399;
    }
    span:hover {
      background-color: #ebeef5;
      // 指针
      cursor: pointer;
    }
  }
  .uploader-file {
    height: initial;
    line-height: initial;
    .el-col-2.file-info-status {
      width: initial;
    }
  }
  .uploader-file-info {
    overflow: initial;
  }
  .uploader-file-actions {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    // .uploader-file-retry{
    //   display: inline;
    // }
  }
  .uploader-file-actions > span {
    margin-top: 0;
  }
  .uploader-file-name {
    width: 100%;
    text-indent: initial;
    font-size: 14px;
  }
  .uploader-file-desc {
    font-size: 12px;
    color: rgba(37, 38, 43, 0.36);
  }
  .uploader-file-progress {
    display: none;
  }
  .uploader-file {
    .uploader-file-remove {
      display: inline;
    }
    .uploader-file-meta:empty {
      display: none;
    }
  }
  .el-icon-upload-success {
    color: #67c23a;
  }
  .el-icon-upload-warning {
    color: $color-danger;
  }
  .el-progress-bar__outer {
    height: 4px !important;
  }
}
</style>
